import type {SegmentedColumnChartDataColumn} from 'shared/components/kp-charts/bar-chart/types';
import type {DonutChartDataPoint} from 'shared/components/kp-charts/donut-chart/types';
import {getColorFromString} from 'src/shared/utils/color-util';
import {KpCalendarManager} from 'src/shared/components/kp-calendar/kp-calendar-manager';
import {jobColorLightness} from 'src/features/sutor/pages/record-detail/tab-pages/reports-optimisation-tab/overviews/types';

export const dayOptimisationOverviewMockData = {
    jobTypeSummaries: [
        {
            name: 'Technik strojní',
            workersCount: 10,
            standardHours: 10,
            overtimeHours: 10,
            weekendHours: 10,
            holidayHours: 10
        },
        {
            name: 'Zámečník',
            workersCount: 10,
            standardHours: 10,
            overtimeHours: 10,
            weekendHours: 10,
            holidayHours: 10
        },
        {
            name: 'Požární hlídka',
            workersCount: 10,
            standardHours: 10,
            overtimeHours: 10,
            weekendHours: 10,
            holidayHours: 10
        },
        {
            name: 'Řezání vodním paprskem CNC',
            workersCount: 10,
            standardHours: 10,
            overtimeHours: 10,
            weekendHours: 10,
            holidayHours: 10
        },
        {
            name: 'Rovnání do lisu 400t',
            workersCount: 10,
            standardHours: 10,
            overtimeHours: 10,
            weekendHours: 10,
            holidayHours: 10
        },
        {
            name: 'Bezpečnostní technik',
            workersCount: 10,
            standardHours: 10,
            overtimeHours: 10,
            weekendHours: 10,
            holidayHours: 10
        }
    ]
};

export function generateMockSegmentedData(): SegmentedColumnChartDataColumn[] {
    const calendarDays = KpCalendarManager.createCalendarData({
        granularity: 'day',
        from: {day: 29, month: 3, year: 2025},
        to: {day: 11, month: 4, year: 2025}
    });

    return calendarDays.map((calendarDay) => {
        const random = Math.random();

        return {
            label: `${calendarDay.day}.${calendarDay.month}.`,
            segments: [
                {label: 'Účtované náklady', value: 20 * random, color: '#F3BDA7'},
                {label: 'Vykázané náklady', value: 80 * random, color: '#D9E1F6'}
            ]
        };
    });
}

export function generateMockDonutData(): DonutChartDataPoint[] {
    return dayOptimisationOverviewMockData.jobTypeSummaries.map((jobTypeSummary) => {
        return {
            label: jobTypeSummary.name,
            value: jobTypeSummary.standardHours + jobTypeSummary.overtimeHours + jobTypeSummary.weekendHours + jobTypeSummary.holidayHours,
            color: getColorFromString(jobTypeSummary.name, jobColorLightness)
        };
    });
}